const TONE_BY_TENDER_STATUS = Object.freeze({
  active: 'success',
  planned: 'info',
  planning: 'info',
  complete: 'destructive',
  canceled: 'destructive',
  withdrawn: 'destructive',
  unsuccessful: 'destructive',
});

export function getTenderStatusTone(status) {
  if (typeof status !== 'string' || !status) return 'neutral';
  return TONE_BY_TENDER_STATUS[status] || 'neutral';
}
